import { render } from "./TypographyPage.vue?vue&type=template&id=f70f6eaa"
import script from "./TypographyPage.vue?vue&type=script&lang=js"
export * from "./TypographyPage.vue?vue&type=script&lang=js"

import exportComponent from "/Users/dorivaldodossantos/Documents/projectos/meus/ggmf/ggmf_front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__